import React from 'react';

import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import servicioCfdi from '../servicios/ServicioCfdi';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioIdioma from '../servicios/ServicioIdiomaFecha';
import { Checkbox } from 'primereact/checkbox';
import servicioArchivos from '../servicios/ServicioArchivos';
import servicioFormatos from '../servicios/ServicioFormatos';
import { Dialog } from 'primereact/dialog';
import servicioCorreo from '../servicios/ServicioCorreo';

export class Cfdi extends React.Component {
    constructor() {
        super();
        this.state = {
            mostrarModal: false,
            mostrarMensaje: false,
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            criterio: {},
            muestraFecha: 'none',
            muestraFolio: 'none',
            muestraRfc: 'none',
            muestraBoton: 'none',
            tipoCriterio: [
                { label: 'Fecha Creación', value: 'fecha' },
                { label: 'RFC Receptor', value: 'rfc' },
                { label: 'Folio Fiscal', value: 'folio' },
            ],
            tipSeleccionado: null,
            cfdis: [],
            modalEnvioCorreos: false,
            enviocorreo: {},
            listaEnvioCorreo: [],
            erroresCorreo: {},
            restriccionSesion:[]
        }
    }

    agregarRestriccionSesion = () => {
        let { paginacion, restriccionSesion } = this.state;
        if (!servicioAsignacionValoresObjetos.esObjetoVacio(restriccionSesion)) {
            paginacion.restriccionesDinamicas=restriccionSesion;
        }
    }

    obtenerResultados = () => {
        this.agregarRestriccionSesion();
        const { paginacion } = this.state;
        servicioCfdi.paginacion(paginacion).then((response) => {
            this.setState({ paginacion: response.data.objeto });
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
        });
    }

    cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerResultados();
    }

    buscarPorFechas = () => {
        let { paginacion, criterio,restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioFecha(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"between",nombrePropiedad:"alias_ttCfdi.fechaCertificacion",
            valorPropiedad:null,fechaIncialBetween:servicioFormatos.formatearFechaStringSinSegundos(criterio.fechaInicial)+" 00:00:00",
            fechaFinalBetween:servicioFormatos.formatearFechaStringSinSegundos(criterio.fechaFinal)+" 23:59:59"}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerResultados();
        }
    }

    buscarPorRfc = () => {
        let { paginacion, criterio,restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioRfcReceptor(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_tcReceptor.rfc",
            valorPropiedad:criterio.rfc}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerResultados();
        }
    }

    buscarPorFolio = () => {
        let { paginacion, criterio,restriccionSesion } = this.state;
        const resultadoValidacion = this.validarFormularioFolioFiscal(criterio);
        this.setState({ errores: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            paginacion['numeroPagina']=0;
            paginacion['restriccionesDinamicas']=[{tipoRestriccion:"eq",nombrePropiedad:"alias_ttCfdi.uuid",
            valorPropiedad:criterio.folio}];
            restriccionSesion=paginacion.restriccionesDinamicas;
            this.setState({paginacion:paginacion,restriccionSesion});
            this.obtenerResultados();
        }
    }

    validarFormularioRfcReceptor = (criterio) => {
        const errores = {};
        let patron = /^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9]{3}$/;

        if (!patron.test(criterio.rfc)) {
            this.growl.show({ life: 7000, severity: 'error', summary: '', detail: 'El RFC no cumple con un patrón válido.  Ejemplo: Persona Física AAAA010101AAA, Persona Moral AAA010101AAA' });
            errores.rfc = "El rfc es inválido";
        }
        return errores;
    }

    validarFormularioFecha = (criterio) => {

        const errores = {};
        if (!criterio.fechaInicial)
            errores.fechaInicial = "El campo requerido";

        if (!criterio.fechaFinal)
            errores.fechaFinal = 'El campo es requerido'

        if (criterio.fechaInicial !== undefined && criterio.fechaInicial !== null)
            if (criterio.fechaInicial.length > 0 && new Date(criterio.fechaInicial).toString() === 'Invalid Date')
                errores.fechaInicial = "Fecha inválida";
        if (criterio.fechaFinal !== undefined && criterio.fechaFinal !== null)
            if (criterio.fechaFinal.length > 0 && new Date(criterio.fechaFinal).toString() === 'Invalid Date')
                errores.fechaFinal = "Fecha inválida";

        return errores;
    }

    validarFormularioFolioFiscal = (criterio) => {
        const errores = {};
        if (!criterio.folio)
            errores.folio = "El campo requerido";

        return errores;
    }

    descargaRepresentacionImpresa = (rowData, column) => {
        return <div>
            <div>
                <Button type="button" icon="pi-md-file-download" className="p-button-danger" name="pdf"
                    tooltip="Descargar pdf" onClick={(e) => this.generaDescarga(column.rowData, 'pdf')} >
                </Button>
            </div>
        </div>;
    }

    descargaXmlSaT = (rowData, column) => {
        return <div>
            <div className="p-col-12 p-md-4">
                <Button type="button" icon="pi-md-file-download" className="p-button-success" name="xml"
                    tooltip="Descargar xml" onClick={(e) => this.generaDescarga(column.rowData, 'xml')} >
                </Button>
            </div>
        </div>;
    }

    columnaenviarAmiCorreo = (rowData, column) => {
        return <div> <Button icon="pi-md-email" className="deep-orange-btn" type="button" tooltip="Enviar a mi correo"
            onClick={(e) => this.enviarAmiCorreo(column.rowData)}></Button></div>;

    }

    enviarAmiCorreo = (objeto) => {
        servicioCorreo.enviarAmiCorreo({ ttCfdi: objeto.ttCfdi, estado: 0, tipo: 1, rfcEmisor: objeto.tcEmisor.rfc }).then(response => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
        })
    }

    generaDescarga(objeto, tipo) {
        servicioArchivos.descargaArchivo('/documentos/descargar_documentos.json?uuid=' + objeto.ttCfdi.uuid + '&tipo=' + tipo);
            
    }

    asignarValores = (event) => {
        if (event.target.id === 'rfc' || event.target.id === 'folio')
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
        else
            servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    mostrarDivs(event) {
        this.setState({ tipSeleccionado: event.value, muestraBoton: 'block', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} ,restriccionSesion:[]});

        if (event.value === 'folio')
            this.setState({ muestraFecha: 'none', muestraFolio: 'block', muestraRfc: 'none', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });

        if (event.value === 'fecha')
            this.setState({ muestraFecha: 'block', muestraFolio: 'none', muestraRfc: 'none', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });

        if (event.value === 'rfc')
            this.setState({ muestraFecha: 'none', muestraFolio: 'none', muestraRfc: 'block', paginacion: { registrosPorPagina: 20 }, inicio: 0, criterio: {} });
    }

    columnaTotal = (rowData, column) => {
        return <div>{servicioFormatos.formatearModena(rowData.ttCfdi.total)}</div>;
    }


    columnaFechaCreacion = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.ttCfdi.fechaCreacion)}</div>;
    }

    columnaEstatus = (rowData, column) => {
        if (rowData.ttCfdi.estado === 1)
            return <p>Activo</p>
        if (rowData.ttCfdi.estado === 0)
            return <p>Cancelado</p>
    }

    columnaTipoComprobante = (rowData, column) => {
        if (rowData.ttCfdi.tipoFactura === 0)
            return <p>Factura de pagos</p>
        if (rowData.ttCfdi.tipoFactura === 1)
            return <p>Factura de emergencia</p>
        if (rowData.ttCfdi.tipoFactura === 2)
            return <p>Factura de Peaje</p>
        if (rowData.ttCfdi.tipoFactura === 3)
            return <p>Factura reexpedida</p>
        if (rowData.ttCfdi.tipoFactura === 4)
            return <p>Ingresos diversos</p>
        if (rowData.ttCfdi.tipoFactura === 5)
            return <p>Ingresos diversos/Nota de crédito</p>
        if (rowData.ttCfdi.tipoFactura === 6)
            return <p>Nota de crédito</p>

    }

    columnaVariosCorreos = (rowData, column) => {
        return <div>
            <Checkbox inputId={rowData.uuid} value={rowData} onChange={this.asignarCfdis.bind(this)} checked={this.state.cfdis.includes(rowData)}></Checkbox>
        </div>;
    }

    asignarCfdis(e) {
        let { cfdis } = this.state;

        if (e.checked)
            cfdis.push(e.value);
        else
            cfdis.splice(cfdis.indexOf(e.value), 1);

        this.setState({ cfdis });

    }

    enviarCfdis = () => {
        let { cfdis } = this.state;
        if (cfdis.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: "Selecciona al menos un comprobante" });
        this.setState({ modalEnvioCorreos: true, listaEnvioCorreo: [] });
        this.renderTableData();
    }

    agregarCorreos = () => {
        const { listaEnvioCorreo, enviocorreo } = this.state;
        const resultadoValidacion = this.validarFormularioCorreo(enviocorreo);
        this.setState({ erroresCorreo: resultadoValidacion });
        if (!Object.keys(resultadoValidacion).length) {
            listaEnvioCorreo.push(enviocorreo.correo);
            enviocorreo['correo'] = '';
            this.setState({ listaEnvioCorreo, enviocorreo: enviocorreo });
            this.renderTableData();
        }

    }

    validarFormularioCorreo = (enviocorreo) => {
        const errores = {};
        if (!enviocorreo.correo)
            errores.correo = "El campo requerido";

        return errores;
    }

    renderTableData = () => {
        return this.state.listaEnvioCorreo.map((correo, index) => {
            return (
                <tr key={index}>
                    <td>{correo}</td>
                    <td><span className="p-inputgroup-addon" onClick={this.eliminarCorreo.bind(this)}><i className="pi-md-delete-forever" ></i></span></td>
                </tr>
            )
        })
    }

    eliminarCorreo = (rowData, column) => {
        const { listaEnvioCorreo } = this.state;
        listaEnvioCorreo.splice(listaEnvioCorreo.indexOf(rowData), 1);
        this.setState({ listaEnvioCorreo });
        this.renderTableData();
    }

    enviarVariosCorreos = () => {
        let { listaEnvioCorreo, cfdis } = this.state;

        if (listaEnvioCorreo.length === 0)
            return this.growl.show({ life: 3000, severity: 'error', summary: 'error', detail: "Debes agregar un correo" });

        const listaEnvioCorreos = [];
        listaEnvioCorreo.forEach(correo => {
            cfdis.forEach(cfdi => {
                listaEnvioCorreos.push({ ttCfdi: cfdi.ttCfdi, correos: correo, estado: 0, tipo: 1, rfcEmisor: cfdi.tcEmisor.rfc });
            })
        })
        servicioCorreo.enviarCorreo(listaEnvioCorreos).then(response => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'Error'), summary: '', detail: response.data.mensaje });
            if (!response.data.error) {
                this.setState({ listaEnvioCorreos: [], enviocorreo: {}, erroresCorreo: {}, modalEnvioCorreos: false, cfdis: [] });
                this.renderTableData();
            }
        })
    }


    render() {
        let { errores, criterio, paginacion, inicio, muestraFecha, muestraFolio, muestraRfc, tipoCriterio, muestraBoton, enviocorreo, erroresCorreo } = this.state;

        const dialogFooter = (
            <div>
                <Button icon="pi-md-email" label="Enviar" onClick={this.enviarVariosCorreos} />
                <Button icon="pi-md-close" label="Cancelar" className="p-button-danger" onClick={() => this.setState({ listaEnvioCorreos: [], enviocorreo: {}, erroresCorreo: {}, modalEnvioCorreos: false, cfdis: [] })} />
            </div>
        );

        return (
            <div className="content-section implementation">
                <Growl ref={(el) => this.growl = el} />

                <div className="card card-w-title">
                    <h1>Envío y Reenvío de Facturas (CFDI)</h1>
                    <div className="p-grid  p-fluid">

                        <div className="p-col-12 p-md-12">
                            <Dropdown value={this.state.tipSeleccionado} options={tipoCriterio} style={{ width: '50%' }}
                                onChange={this.mostrarDivs.bind(this)} placeholder="Selecciona un criterio de busqueda" />
                            <br /><br />
                        </div>
                    </div>

                    <div style={{ display: muestraFecha }}>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-2">
                                <label htmlFor="fechaInicial">*Fecha Inicial</label>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Calendar id="fechaInicial" name="criterio.fechaInicial" className={errores.fechaInicial ? 'p-error' : ''} value={criterio.fechaInicial || ''} locale={servicioIdioma} onChange={this.asignarValores} showIcon={true} dateFormat="yy-mm-dd" />
                                {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}
                            </div>

                            <div className="p-col-12 p-md-2">
                                <label htmlFor="fechaFinal">*Fecha Final</label>
                            </div>
                            <div className="p-col-12 p-md-3">
                                <Calendar id="fechaFinal" name="criterio.fechaFinal" className={errores.fechaFinal ? 'p-error' : ''} value={criterio.fechaFinal || ''} locale={servicioIdioma} onChange={this.asignarValores} showIcon={true} dateFormat="yy-mm-dd" />
                                {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}
                            </div>
                            <div className="p-col-12 p-md-2">
                                <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorFechas} />

                            </div>
                        </div>
                    </div>


                    <div className="p-col-12 p-md-12">
                        <div style={{ display: muestraFolio }}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <br />  <br /> <br />
                                        <span className="p-inputgroup-addon"><i className="material-icons">description</i></span>
                                        <InputText placeholder="UUID" maxLength={38} id="folio" name="criterio.folio" className={errores.folio ? 'p-error' : ''} value={criterio.folio || ''}
                                            onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                                    </div>
                                    {errores.folio ? <div><br /> <Message severity="error" text={errores.folio} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <br />  <br />
                                    <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorFolio} />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-12">
                        <div style={{ display: muestraRfc }}>
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-6">
                                    <div className="p-inputgroup">
                                        <br />  <br /> <br />
                                        <span className="p-inputgroup-addon"><i className="material-icons">person</i></span>
                                        <InputText placeholder="RFC" maxLength={13} id="rfc" name="criterio.rfc" className={errores.rfc ? 'p-error' : ''} value={criterio.rfc || ''}
                                            onChange={this.asignarValores} style={{ width: '100%' }} />
                                    </div>
                                    {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <br />  <br />
                                    <Button label="Buscar" className="teal-btn flat-btn" onClick={this.buscarPorRfc} />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12">
                        <div style={{ display: muestraBoton }}>
                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <Button className="p-button-Primary p-button-raised" label="Enviar a otro(s) correos"
                                        icon="pi-md-contact-mail" tooltip="Enviar a otro(s) correos" onClick={this.enviarCfdis} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog header="Enviar a otro(s) correos" visible={this.state.modalEnvioCorreos} modal={true} style={{ width: '30vw' }} footer={dialogFooter} onHide={() => this.setState({ modalEnvioCorreos: false })}>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="fechaFinal">*Agrega correos:</label>
                        </div>
                        <div className="p-col-12 p-md-10">
                            <InputText placeholder="Escribe el correo" id="enviocorreo" name="enviocorreo.correo" className={erroresCorreo.correo ? 'p-error' : ''} value={enviocorreo.correo || ''}
                                onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                            {erroresCorreo.correo ? <div><br /> <Message severity="error" text={erroresCorreo.correo} /> </div> : null}
                        </div>
                        <div className="p-col-12">
                            <Button label="Agregar" className="teal-btn flat-btn" onClick={this.agregarCorreos}></Button>
                        </div>

                        <div className="p-col-12">
                            <table id='listaEnvioCorreo'>
                                <tbody>
                                    {this.renderTableData()}
                                </tbody>
                            </table>

                        </div>

                    </div>
                </Dialog>

                <div className="content-section implementation">
                    <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px" responsive={true} header="Mis facturas de peaje">
                        <Column header="Varios correos" body={this.columnaVariosCorreos} style={{ width: '80px' }} autoLayout={true} />
                        <Column header="Descarga Pdf" body={this.descargaRepresentacionImpresa.bind(this)} style={{ width: '80px' }} />
                        <Column header="Descarga Xml" body={this.descargaXmlSaT.bind(this)} style={{ width: '80px' }} autoLayout={true} />
                        <Column header="Enviar a mi correo" body={this.columnaenviarAmiCorreo.bind(this)} style={{ width: '80px' }} autoLayout={true} />
                        <Column field="ttCfdi.uuid" header="UUID" style={{ width: '200px' }} autoLayout={true} />
                        <Column body={this.columnaTotal} header="Total" style={{ width: '200px' }} autoLayout={true} />
                        <Column field="ttCfdi.folio" header="Folio" style={{ width: '200px' }} autoLayout={true} />
                        <Column field="ttCfdi.serie" header="Serie" style={{ width: '200px' }} autoLayout={true} />
                        <Column body={this.columnaFechaCreacion} header="Fecha Creacion" style={{ width: '200px' }} autoLayout={true} />
                        <Column field="tcEmisor.rfc" header="R.F.C. Emisor" style={{ width: '200px' }} autoLayout={true} />
                        <Column field="tcReceptor.rfc" header="R.F.C. Receptor" style={{ width: '200px' }} autoLayout={true} />
                        <Column body={this.columnaEstatus} header="Estatus" style={{ width: '200px' }} autoLayout={true} />
                        <Column body={this.columnaTipoComprobante} header="Tipo Comprobante" style={{ width: '200px' }} autoLayout={true} />
                    </DataTable>
                    <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                </div>
            </div>
        );
    }


}